import { Course } from "../../../shared/types";
import { sanitizeImgUrls } from "../helpers/functions";
import { get, GetAllResponse, GetResponse, post, put } from "./_base";

const path = "courses";

const sanitizeCourse = (response: GetResponse<Course>): GetResponse<Course> => {
  return {
    ...response,
    data: sanitizeCourseData(response.data),
  };
};

const sanitizeCourseData = (course: Course): Course => {
  return {
    ...course,
    image: {
      ...course.image,
      path: sanitizeImgUrls(course.image?.path),
    },
    text: sanitizeImgUrls(course.text),
  };
};

const sanitizeCourses = (
  response: GetAllResponse<Course>
): GetAllResponse<Course> => {
  return {
    ...response,
    data: response.data.map(sanitizeCourseData),
  };
};

export class CourseActions {
  static post = async (data: Course) => {
    return await post(path, data);
  };
  static get = async (data: Partial<Course>) => {
    const response = (await get(path, data, {
      single: true,
    })) as GetResponse<Course>;

    return sanitizeCourse(response);
  };
  static getAll = async (data: Partial<Course>) => {
    const response = (await get(path, data)) as GetAllResponse<Course>;

    return sanitizeCourses(response);
  };
  static put = async (data: Course) => {
    return await put(path, data);
  };
}
